var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"oil"},[_c('img',{style:({ height:_vm.bannerHeight+'px' }),attrs:{"src":(_vm.$ossUrl + "image/activePage/oneKeyToOil/oneKey.png"),"alt":""},on:{"click":_vm.toOneCallOil}})])}
var staticRenderFns = []

export { render, staticRenderFns }